import { Button } from './Button';

interface ModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonText: string;
  cancelButtonText: string;
  primaryMessage: string;
  secondaryMessage: string;
  primaryDisabled?: boolean;
  secondaryDisabled?: boolean;
}

export const Modal = (props: ModalProps) => {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-solid-deep-blue/70 z-10 flex items-center justify-center">
      <div className="flex flex-col h-[160px] w-1/4 bg-elevation-1 z-20 justify-between p-4">
        <p className="text-center">
          {props.primaryMessage}
          <br />
          {props.secondaryMessage}
        </p>
        <div className="flex flex-row w-full justify-center gap-8">
          <Button text={props.confirmButtonText} primary onClick={() => props.onConfirm()} disabled={props.primaryDisabled} />
          <Button text={props.cancelButtonText} primary={false} onClick={() => props.onCancel()} disabled={props.secondaryDisabled} />
        </div>
      </div>
    </div>
  );
};
